// extracted by mini-css-extract-plugin
module.exports = {"swiperDemoBox":"index-swiperDemoBox-38YOp"};